module.exports = __webpack_public_path__ + "static/media/October_2026_5.c77a5ea1.webp";